import AjaxUtils from './ajaxUtils';

const fetchActiveUserIntegration = async () => {
  const userIntegrations = await AjaxUtils.get('/api/v2/user-integrations?status=enabled&$eager=[integration, tokens]');

  // Only single user integration is active
  return userIntegrations[0];
};

const authenticateUserIntegration = async provider => {
  try {
    // eslint-disable-next-line no-undef
    const authentication = await AjaxUtils.get(`/v2/user-integrations-auth?integrationName=${provider}&platform=plugin&version=${WEB_PLUGIN_VERSION}`);

    return authentication.authUrl;
  } catch (e) {
    return undefined;
  }
};

const disconnectUserIntegration = async userIntegrationId => {
  try {
    return AjaxUtils.delete(`/api/v2/user-integrations/${userIntegrationId}`);
  } catch (e) {
    return undefined;
  }
};

const fetchUserIntegrationsAnalytics = async () => {
  try {
    return AjaxUtils.get('/api/v2/user-integrations/analytics');
  } catch (e) {
    return undefined;
  }
};

export {
  authenticateUserIntegration,
  disconnectUserIntegration,
  fetchActiveUserIntegration,
  fetchUserIntegrationsAnalytics,
};
